import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Box, Container, Typography } from "@material-ui/core";
import "../CustomerREQ/CustomerREQ.css";
import ReqMain from "./ReqMain";
import "./Req.css";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
  },
});

const REQ = ({ isShaws }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(2);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // console.log(newValue);
  };
  return (
    <div className={isShaws ? "customer-details" : "customer-details-after"}>
      <Container>
        {" "}
        <Paper className={classes.root}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Box className="reqTab">
              <Typography variant="h6 adminreq">REQ</Typography>
            </Box>
            <Tab label="All" className="newReqShaw" />
            <Tab label="Open" className="approvedShaw" />
            <Tab label="In Progress" className="approvedShaw" />
            <Tab label="Closed" className="approvedShaw" />
          </Tabs>
        </Paper>
        <ReqMain value={value} />
      </Container>
    </div>
  );
};

export default REQ;
